import { useState } from 'react';
import { usePermission } from '../../Auth/permission-context';
import { useBusinessDetail } from '../../context/Business-context';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../InitialColor';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Popover from '@material-ui/core/Popover';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import defaultUser from '../../common/images/avatar.jpeg';
import CloseIcon from '@material-ui/icons/Close';
import RightSlide from '../../HR/Timeoff/Drawer';
import HelpAndLearn from '../../Info/HelpAndLearn';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Apps, { Faqs, GetHelp } from '../../Info/Apps';
import Notification from './Notification';
import { useAuth } from 'Auth/auth-context';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '1em 2em',
    marginBottom: '3em',
    '& .MuiTypography-body2': {
      fontSize: '13px'
    }
  },
  brandName: {
    color: '#737373',
    fontSize: '14.22px',
    fontWeight: 700,
    fontStyle: 'normal'
  },
  menu: {
    '& .MuiGrid-item': {
      textAlign: 'center',
      '& .MuiTypography-body1': {
        fontSize: '14.22px',
        fontWeight: 400,
        fontStyle: 'normal'
      }
    }
  },
  iconRight: {
    '& .MuiGrid-item': {
      textAlign: 'center'
    },
    '& .MuiTypography-body1': {
      fontSize: '14.22px',
      color: '#545454'
    }
  },
  menuPopover: {
    '& .MuiGrid-item': {
      '& .MuiBox-root': {
        margin: '1em 1em',
        padding: '1em 1em',
        cursor: 'pointer',
        background: '#f9f9f9',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        boxShadow:
          '-9.1159px -18.2318px 24.3091px #fff, 9.1159px 18.2318px 24.3091px #eceef1',
        borderRadius: '12.8028px',
        '&:hover': {},
        '& .active': {
          color: 'blue'
        }
      }
    }
  },
  appWrapper: {
    '&:hover': {
      transform: 'scale(1.1)'
    }
  },
  appMenu: {
    fontSize: '.75rem !important',
    color: '#000',
    lineHeight: '1.5em',
    fontWeight: 500
  },
  appIcon: {
    width: '40px',
    height: '65px',
    display: 'inline-block',
    backgroundColor: '#f9f9f9',
    boxShadow:
      '-6.98333px -24.4417px 23.2778px #fff, 6.98333px 24.4417px 23.2778px #e9edf2',
    '&:hover': {
      transform: 'scale(0)'
    },
    '& img': {
      width: '70% !important'
    }
  },
  menuPopoverUser: {
    '& .MuiGrid-item': {
      cursor: 'pointer',
      width: '100%'
    },
    '& .MuiTypography-subtitle2': {
      textAlign: 'left',
      padding: '.8em 0px'
    }
  },
  menuPopoverFooter: {
    '& .MuiGrid-item': {
      padding: '1em 1.2em'
    },
    '& .MuiTypography-subtitle2': {
      color: '#A8A8A8',
      fontSize: '13.61px',
      fontWeight: 400,
      fontStyle: 'normal'
    },
    '& .MuiTypography-body1': {
      color: '#A8A8A8',
      fontSize: '13.61px',
      fontWeight: 400,
      fontStyle: 'normal'
    }
  },
  test: {
    '& .MuiPopover-paper': {
      marginTop: '1em',
      maxWidth: '380px',
      background: '#f5f7f7',
      '& .MuiGrid-item': {
        color: '#737373'
      }
    }
  },
  dropdown: {
    '& .MuiPopover-paper': {
      width: '300px',
      marginTop: '1.8em',
      borderRadius: '20px',
      textAlign: 'center',
      padding: '1.5em 1.2em'
      // padding: '1em'
    }
  },
  summary: {
    marginTop: '10px',
    '& .MuiTypography-body1': {
      color: '#545454',
      fontSize: '18px',
      fontWeight: 700,
      fontStyle: 'normal'
    },
    '& .MuiTypography-subtitle2': {
      color: '#545454',
      fontSize: '12px',
      fontWeight: 400,
      fontStyle: 'normal'
    },
    '& .MuiAvatar-root': {
      margin: 'auto'
    }
  },
  edit: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: '#545454',
    border: '1px solid #2898A4',
    padding: '5px 20px',
    borderRadius: '18px',
    '& .MuiSvgIcon-root': {
      color: '#545454',
      fontSize: '14px',
      marginLeft: '.2em'
    }
  },
  handleViewCompany: {
    background: '#E0EEF0',
    color: '#2898A4',
    padding: '8px 20px',
    borderRadius: '34px',
    width: '75%',
    margin: '.6em auto',
    cursor: 'pointer'
  },
  small: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    border: '1px solid #e5e5e5'
  },
  medium: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    border: '1px solid #e5e5e5'
  },
  addBusiness: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    padding: '1em 0px 0px',
    cursor: 'pointer',
    fontSize: '12px',
    '& .MuiSvgIcon-root': {
      fontSize: '18px'
    }
  }
}));

function TopNavBilling({ toggleWidth, hide }) {
  const classes = useStyles();
  const { data: BusinessName } = useBusinessDetail();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const { data: userData } = useAuth();
  const { data: user } = usePermission();

  const [openInfo, setOpenInfo] = useState(false);
  const [openNotif, setOpenNotif] = useState(false);
  const [stage, setStage] = useState('Help and Learn');

  const handleClickUser = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseUser = () => {
    setAnchorElUser(null);
  };

  const toggleOpenInfo = () => {
    setOpenInfo(!openInfo);
  };

  const open = Boolean(anchorEl);
  const openUser = Boolean(anchorElUser);

  const handleLogoutUser = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('business_domain');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  const stages = {
    'Help and Learn': <HelpAndLearn setStage={setStage} />,

    Apps: <Apps setStage={setStage} />,
    'Get Help': <GetHelp setStage={setStage} />,
    FAQS: <Faqs setStage={setStage} />
  };

  const handleCurrentBusiness = (id) => {
    if (localStorage.getItem('business_domain')) {
      localStorage.setItem('business_domain', id);
      // setIsCurrentBusiness(id);
      window.location.reload();
    }
  };

  return (
    <Wrapper hide={hide}>
      <RightSlide
        state={openInfo}
        setState={setOpenInfo}
        className='side-drawer2'
      >
        <Box
          display='flex'
          alignItems='center'
          justifyContent='space-between'
          className='header'
        >
          <div className='heading'>
            {stage !== 'Help and Learn' && (
              <IconButton>
                <KeyboardBackspaceIcon
                  onClick={() => setStage('Help and Learn')}
                  style={{ verticalAlign: 'middle' }}
                />
              </IconButton>
            )}
            {stage}
          </div>
          <Box textAlign='end'>
            <IconButton>
              <CloseIcon
                onClick={(e) => {
                  e.stopPropagation();
                  toggleOpenInfo();
                }}
                style={{ cursor: 'pointer' }}
              />
            </IconButton>
          </Box>
        </Box>

        {stages[stage]}
      </RightSlide>

      <RightSlide
        state={openNotif}
        setState={setOpenNotif}
        className='side-drawer2'
      >
        <Box
          display='flex'
          alignItems='center'
          justifyContent='space-between'
          className='header'
        >
          <div className='heading'>Notification</div>
          <Box textAlign='end'>
            <IconButton>
              <CloseIcon
                onClick={(e) => {
                  e.stopPropagation();
                  // toggleOpenNotif();
                  setOpenNotif(false);
                }}
                style={{ cursor: 'pointer' }}
              />
            </IconButton>
          </Box>
        </Box>
        <Notification closeModal={() => setOpenNotif(false)} />
        {/* {stages[stage]} */}
      </RightSlide>
      <Box
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Box style={{ width: '' }}>
          <Link to='/dashboard'>
            <img
              src='https://res.cloudinary.com/dgny8sjrg/image/upload/v1638786088/Bizedge_Frontend_Assets/Bizedge_logo_axcwlg.svg'
              alt='logo'
              width={100}
              height={50}
            />
          </Link>
        </Box>
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Box
            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            onClick={handleClickUser}
          >
            <Avatar
              alt='business logo'
              src={
                BusinessName && BusinessName.logo !== null
                  ? BusinessName.logo
                  : defaultUser
              }
              className={classes.small}
            />
            <KeyboardArrowDownRoundedIcon />
          </Box>
        </Box>
      </Box>
      <Box className={classes.popoverWrapper}>
        <Popover
          className={classes.test}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
        >
          <Grid container>
            <Grid item sm={12}>
              <Divider />
            </Grid>
          </Grid>
          <Grid
            container
            alignItems='center'
            justify='space-between'
            className={classes.menuPopoverFooter}
          >
            <Grid item>
              <img
                src='https://res.cloudinary.com/dgny8sjrg/image/upload/v1638787771/Bizedge_Frontend_Assets/brand_nwno9e.svg'
                alt='bizedge logo'
              />
            </Grid>
          </Grid>
        </Popover>
      </Box>
      <Box className={classes.popoverWrapperUser}>
        <Popover
          className={classes.dropdown}
          open={openUser}
          anchorEl={anchorElUser}
          onClose={handleCloseUser}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          <Box className={classes.summary}>
            <Avatar
              alt='business logo'
              src={
                BusinessName && BusinessName.logo !== null
                  ? BusinessName.logo
                  : defaultUser
              }
              className={classes.medium}
            />
            <Typography variant='body1'>
              {BusinessName && BusinessName.name}
            </Typography>
            {user && (
              <>
                <Typography variant='subtitle2'>
                  {`${user.first_name} ${user.last_name}`}
                </Typography>
                <Typography variant='subtitle2'>{`${user.email}`}</Typography>
              </>
            )}
          </Box>
          <Box style={{ margin: '1em 0px 10px' }}>
            <Divider />
          </Box>
          {/* <Box style={{ padding: '2em 0px' }}> */}
          {userData?.business_user_memberships
            .filter((item) => item.business_name !== BusinessName?.name)
            .slice(0, 3)
            .map((item) => (
              <Grid
                container
                alignItems='center'
                justify='flex-start'
                spacing={1}
                style={{ cursor: 'pointer' }}
                onClick={() => handleCurrentBusiness(item.business_id)}
              >
                <Grid item style={{ margin: '.3em 0px' }}>
                  <Avatar
                    className={classes.small}
                    style={{
                      background: colors[item?.business_name.charAt(0)],
                      textTransform: 'capitalize'
                    }}
                  >
                    {item?.business_name.charAt(0)}
                  </Avatar>
                </Grid>
                <Grid item>
                  <Typography>{item?.business_name}</Typography>
                </Grid>
              </Grid>
            ))}
          <Grid container className={classes.menuPopoverUser}>
            <Grid item>
              <Typography variant='subtitle2' onClick={handleLogoutUser}>
                Sign Out
              </Typography>
            </Grid>
          </Grid>
        </Popover>
      </Box>
    </Wrapper>
  );
}

export default TopNavBilling;

const Wrapper = styled(Box)`
  ${({ theme, hide }) => `
  position: fixed;
  display: ${hide === 'true' ? 'none' : 'flex'};
  // border: 1px solid green;
  // z-index: 4;
  // border-bottom: 1px solid #F2F2F2;
  box-shadow: 0px 6px 6px rgba(215, 215, 215, 0.15);
  padding: .8em 2em;
  // padding: 15px 150px;
  // margin-bottom: 1em;
  z-index: 8;
  width: 100%;
  background: white;
  `}
`;
